import { Flex } from "antd";
import { JobDto } from "../../constant";
import styles from "./index.module.less";
import TimeIcon from '../../imgs/time.svg?react'
import LocationIcon from '../../imgs/location.svg?react'
import CategoryIcon from '../../imgs/category.svg?react'

const JobDetail = ({ data, onSubmit }: { data: JobDto, onSubmit: () => void }) => {
  const { title, desc, date, locations, category, requirement } = data;
  return (
    <div className={styles.jobDetail}>
      <Flex justify="space-between" align="center">
        <div className={styles.title}>{title}</div>
        <div className={styles.submitBtn} onClick={onSubmit}>立即投递</div>
      </Flex>
      <Flex gap={".2rem"} className={styles.info}>
        <Flex gap={4} align="center"><CategoryIcon />{category}</Flex>
        <Flex gap={4} align="center"><LocationIcon />{locations.join("/")}</Flex>
        <Flex gap={4} align="center"><TimeIcon />更新于{date}</Flex>
      </Flex>
      <div>
        <div className={styles.requirementsTitle}>职位描述</div>
        <div className={styles.requirementsList}>
          {/* {requirements?.map((item, index) => (
            <div key={index}>
              {index + 1}、{item}
            </div>
          ))} */}
          <div className={styles.desc}>{requirement}</div>
        </div>
      </div>
      <div>
        <div className={styles.descTitle}>职位要求</div>
        <div className={styles.desc}>{desc}</div>
      </div>
      <div className={styles.footerSubmitBtn} onClick={onSubmit}>立即投递</div>
    </div>
  );
};
export default JobDetail;
